import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=c2e28c96&scoped=true&"
import script from "./input-number.vue?vue&type=script&lang=js&"
export * from "./input-number.vue?vue&type=script&lang=js&"
import style0 from "./input-number.vue?vue&type=style&index=0&id=c2e28c96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e28c96",
  null
  
)

export default component.exports